module.exports = __webpack_public_path__ + "static/media/logo.075a12a5.png";